
export default function Footer() {
  return (
    <footer>
      {/* Bluekite Footer Section - full width */}
      <div className="bg-[#e8e8f8] pb-10 pt-0 mt-16">
        {/* Giant BLUEKITE text */}
        <div className="w-full overflow-hidden">
          <img
            src="/BLUEKITE.png"
            alt="BLUEKITE"
            className="w-full h-auto block"
          />
        </div>

        {/* Mobile bottom content */}
        <div className="block sm:hidden px-6 mt-8 flex flex-col gap-6">
          <p className="text-gray-800 text-lg font-medium leading-snug">
            ©Bluekite Consults Branding
            <br />& Public Relation Agency
          </p>

          <div className="flex flex-row gap-2">
  {["LinkedIn", "Instagram", "TikTok", "Twitter"].map((social) => (
    
     <a key={social}
      href="/"
      className="bg-[#c8c8f0] text-gray-800 text-xs font-medium px-2 py-2 rounded-xl hover:bg-[#b0b0e8] transition-colors text-center flex-1"
    >
      {social}
    </a>
  ))}
</div>

          <div className="mt-4 flex flex-col gap-2">
            <p className="text-gray-800 text-lg">
              ©Bluekite Consult 2022. All Rights Reserved.
            </p>
            <p className="text-gray-800 text-2xl font-medium">
              ©BluekiteConsult
            </p>
          </div>
        </div>

        {/* Desktop bottom bar */}
        <div className="hidden sm:flex sm:w-11/12 mx-auto px-4 sm:px-0 mt-8 items-end justify-between flex-wrap gap-6">
          <div className="flex flex-col gap-4">
            <p className="text-gray-700 text-sm">
              ©Bluekite Consults | Branding & Public Relation Agency
            </p>
            <div className="flex items-center gap-3 flex-wrap">
              {["LinkedIn", "Instagram", "TikTok", "Twitter"].map((social) => (
                
                <a  key={social}
                  href="/"
                  className="bg-[#c8c8f0] text-gray-800 text-sm font-medium px-5 py-2 rounded-full hover:bg-[#b0b0e8] transition-colors"
                >
                  {social}
                </a>
              ))}
            </div>
          </div>
          <div className="text-right text-sm text-gray-700 flex flex-col gap-1">
            <p>©Bluekite Consult 2022. All Rights Reserved.</p>
            <p>©BluekiteConsult</p>
          </div>
        </div>
      </div>

      {/* Grant Canyon Footer Section */}
      <div className="bg-[#ffffff] py-3 text-white">
      </div>
    </footer>
  );
}